export default function DragAndDropIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
    >
      <ellipse
        cx="12"
        cy="8.00049"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 12 8.00049)"
        fill="#AFBACA"
      />
      <ellipse
        cx="7"
        cy="8.00049"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 7 8.00049)"
        fill="#AFBACA"
      />
      <ellipse
        cx="2"
        cy="8.00049"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 2 8.00049)"
        fill="#AFBACA"
      />
      <ellipse
        cx="12"
        cy="2.00049"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 12 2.00049)"
        fill="#AFBACA"
      />
      <ellipse
        cx="7"
        cy="2.00049"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 7 2.00049)"
        fill="#AFBACA"
      />
      <ellipse
        cx="2"
        cy="2.00049"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 2 2.00049)"
        fill="#AFBACA"
      />
    </svg>
  );
}
